<template>
  <component :is="to ? 'RouterLink' : 'div'" :to="to || undefined"
      class="w-full flex items-center py-2 px-3 rounded-lg cursor-pointer transition relative"
      :class="[
      active ? 'bg-white shadow' : '',
      collapsed ? 'justify-center' : 'justify-between'
    ]"
  >
    <!-- Left Icon and Label -->
    <div
        class="flex items-center gap-3"
        :class="collapsed ? 'justify-center' : ''"
    >
      <div class="relative">
        <SvgIcon
            :name="icon"
            class="shrink-0"
            :class="active ? 'text-secondary' : 'text-light'"
        />

        <!-- Dot Badge when collapsed -->
        <div
            v-if="badge && collapsed"
            class="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full"
        ></div>
      </div>

      <!-- Label -->
      <span
          v-if="!collapsed"
          class="truncate transition-opacity duration-300"
          :class="active ? 'text-primary font-bold' : 'text-primary/40 font-medium'"
      >
        {{ label }}
      </span>
    </div>

    <!-- Badge when expanded -->
    <span
        v-if="badge && !collapsed"
        class="badge badge-xs rounded-full bg-red-500 text-white px-1.5 border-none text-[10px]"
    >
    {{ badge }}
  </span>
  </component>
</template>

<script setup>
import SvgIcon from "@/components/atoms/SvgIcon.vue";
import {computed} from "vue";
import {useRoute} from "vue-router";

const props = defineProps({
  icon: String,
  label: String,
  badge: {type: Number, default: null},
  collapsed: {type: Boolean, default: false},
  to: {type: [String, Object], required: false, default: null}
});


const route = useRoute()

const active = computed(() => {
  if (!props.to) return false
  const currentPath = route.path
  const toName = typeof props.to === 'string' ? props.to : props.to.name
  const targetRoute = route.matched.find(r => r.name === toName) || route.matched[1]?.children?.find(r => r.name === toName)
  return targetRoute && currentPath.startsWith(targetRoute.path)
})
</script>